import { scopedCollection } from '@adornis/bh-util/server/scoped-collection.js';
import type { PaymentPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { Participation } from '@adornis/buchungsheld-db/entities/Participation.js';
import { ParticipationState } from '@adornis/buchungsheld-db/enums/enums.js';
import { defaultPaymentPlugin } from './default.js';

export const immediateParticipationPaymentPlugin: PaymentPlugin<'card' | 'paypal', 'default'> = {
  id: 'payment::immediate-participation',
  type: 'payment',
  paymentMethods: defaultPaymentPlugin.paymentMethods,
  getProductPrice: defaultPaymentPlugin.getProductPrice,
  createPayment: defaultPaymentPlugin.createPayment,
  pay: defaultPaymentPlugin.pay,
  sendInvoice: defaultPaymentPlugin.sendInvoice,
  cancleEnrollment: defaultPaymentPlugin.cancleEnrollment,
  onPaymentUpdate: defaultPaymentPlugin.onPaymentUpdate,
  priceGroups: defaultPaymentPlugin.priceGroups,
  afterEnrollment: async participationID => {
    await defaultPaymentPlugin.afterEnrollment(participationID);
    const c = await scopedCollection(Participation);
    await c.updateOne({ _id: participationID }, { $set: { state: ParticipationState.participated } });
  },
};
